var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31887 5.32091C3.12558 5.32189 2.93229 5.25227 2.78329 5.10911L0.866464 3.2656C0.570484 2.97927 0.567463 2.51447 0.860424 2.22617C1.15338 1.9369 1.63158 1.93396 1.92857 2.21931L3.3078 3.54507L6.67533 0.224792C6.9693 -0.0644822 7.4475 -0.067424 7.74348 0.217927C8.04047 0.50426 8.04349 0.970039 7.75053 1.25735L3.85144 5.10224C3.70445 5.24737 3.51217 5.31993 3.31887 5.32091",
    fill: "#4D70B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBlue);
export default __webpack_public_path__ + "static/media/tick_blue.0c5903ef745ad038cfbb48d024494509.svg";
export { ForwardRef as ReactComponent };